export default "__VITE_ASSET__BYmHeooS__"